import React from "react";

interface TableProps {
  data: {
    metric: string;
    target: number;
    achieved: number;
  }[];
}

const PerformanceTable: React.FC<TableProps> = ({ data }) => {
  return (
    <div className="bg-white rounded-xl shadow p-5 w-full h-full flex flex-col">
      <h2 className="text-lg font-semibold mb-4">Performance Breakdown</h2>

      <div className="overflow-x-auto">
        <table className="w-full text-sm border-collapse">
          <thead className="bg-gray-100">
            <tr className="text-left">
              <th className="py-3 px-4 font-medium">Metric</th>
              <th className="py-3 px-4 font-medium">Target</th>
              <th className="py-3 px-4 font-medium">Achieved</th>
              <th className="py-3 px-4 font-medium">Remaining</th>
              <th className="py-3 px-4 font-medium">Percentage</th>
            </tr>
          </thead>

          <tbody>
            {data.map((row, idx) => {
              const remaining = Math.max(row.target - row.achieved, 0);
              const percentage =
                row.target > 0
                  ? ((row.achieved / row.target) * 100).toFixed(1)
                  : "0%";

              return (
                <tr key={idx} className="border-b hover:bg-gray-50">
                  <td className="py-3 px-4">{row.metric}</td>
                  <td className="py-3 px-4">{row.target}</td>
                  <td className="py-3 px-4">{row.achieved}</td>
                  <td className="py-3 px-4">{remaining}</td>
                  <td className="py-3 px-4">{percentage}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PerformanceTable;
